import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import "./VehicleTypeImages.css";
import { VehicleTypeCategoryEnum } from "./api/Representation";
const VehicleTypeCategoryImg = ({ category, size = 'lg', className = '' }) => {
    return (_jsx("span", { className: `${className} img-fluid vehicle-category-img vehicle-category-img-${size}-${category} vehicle-category-img-${category}` }));
};
export default VehicleTypeCategoryImg;
